import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { saveProjectDescriptorByKey } from '../../element-editor/store/editor.actions';

@Component({
  selector: 'nw-file-project-definitions-json-modal',
  templateUrl: './file-project-json-modal.component.html',
  styleUrls: ['./file-project-definitions-json-modal.component.scss'],
})
export class FileProjectDefinitionsJsonModalComponent
  implements OnInit, OnDestroy
{
  @Output() close = new EventEmitter<void>();
  @Output() save = new EventEmitter<any>();

  _jsonText = '';

  @Input()
  set jsonText(v: string) {
    this.originalValue = v;
    this._jsonText = this.pretty(v);
    this.errorMsg = null;
  }

  originalValue: any;
  errorMsg: string | null = null;
  private sub?: Subscription;
  constructor(private readonly store: Store) {}
  ngOnInit(): void {}
  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
  onBackdropClick(event: MouseEvent) {
    if (event.target === event.currentTarget) {
      this.close.emit();
    }
  }
  format() {
    try {
      const obj = JSON.parse(this._jsonText || '{}');
      this._jsonText = this.pretty(obj);
      this.errorMsg = null;
    } catch (e: any) {
      this.errorMsg = e?.message || 'Invalid JSON';
    }
  }

  reset() {
    this._jsonText = this.pretty(this.originalValue ?? {});
    this.errorMsg = null;
  }

  validate() {
    try {
      JSON.parse(this._jsonText || '{}');
      this.errorMsg = null;
    } catch (e: any) {
      this.errorMsg = e?.message || 'Invalid JSON';
    }
  }

  saveModal() {
    console.log('modal-save');
    try {
      const value = JSON.parse(this._jsonText || '{}');
      this.save.emit(value);
    } catch (e: any) {
      this.errorMsg = e?.message || 'Invalid JSON';
    }
  }

  cancel() {
    this.close.emit();
  }

  private pretty(v: any) {
    return JSON.stringify(v ?? {}, null, 2);
  }
}
